var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 111,
    viewBox: "0 0 111 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.1
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.4548 94.0422C115.836 72.661 115.836 37.9952 94.4548 16.614C73.0736 -4.76718 38.4078 -4.76718 17.0266 16.614C-4.35461 37.9952 -4.35461 72.661 17.0266 94.0422C38.4078 115.423 73.0736 115.423 94.4548 94.0422Z",
    fill: "#246BFD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.7c9b0a93e080fe797a9ee39dd66aee9d.svg";
export { ForwardRef as ReactComponent };